import { render, staticRenderFns } from "./Commande.vue?vue&type=template&id=58e86a90&scoped=true&"
import script from "./Commande.vue?vue&type=script&lang=js&"
export * from "./Commande.vue?vue&type=script&lang=js&"
import style0 from "./Commande.vue?vue&type=style&index=0&id=58e86a90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e86a90",
  null
  
)

export default component.exports